"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormLabel, Input, forwardRef } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../SvgSprite";
import textStyles from "../../../theme/foundations/generated/textStyles";
import { getCursorFromInputState, getThumbBackgroundColorFromInputState, getThumbColorFromInputState, } from "./Switch.helpers";
// TODO: refacto with proper multi parts component theming
const Switch = forwardRef((_a, ref) => {
    var { isChecked, isDisabled, isReadOnly, isLeftLabel, children, id = "switch", onChange } = _a, props = __rest(_a, ["isChecked", "isDisabled", "isReadOnly", "isLeftLabel", "children", "id", "onChange"]);
    return (_jsxs(FormLabel, Object.assign({ htmlFor: id, as: "label", display: "inline-flex", alignItems: "start", justifyContent: isLeftLabel ? "space-between" : "flex-start", position: "relative", gap: 2, maxWidth: "24rem" }, (isLeftLabel ? { width: "24rem" } : {}), { cursor: getCursorFromInputState({ isDisabled, isReadOnly }), m: 0, sx: Object.assign(Object.assign({ "input[type=checkbox] ~ .thumb": {
                color: getThumbColorFromInputState({ isReadOnly }),
            }, "input[type=checkbox]:checked ~ .thumb": {
                color: getThumbColorFromInputState({ isReadOnly }),
            } }, textStyles.body.largeDemibold), { color: isDisabled ? "semantic.text.disabled" : "semantic.text.primary" }) }, { children: [isLeftLabel && children, _jsxs(Box, Object.assign({ display: "inline-flex", width: "2.75rem" }, { children: [_jsx(Input, Object.assign({ ref: ref, id: id, type: "checkbox", checked: isChecked, onChange: onChange, isDisabled: isDisabled || isReadOnly, display: "inline-block", appearance: "none", cursor: getCursorFromInputState({ isDisabled, isReadOnly }), height: "1.5rem", width: "2.75rem", p: 0, backgroundColor: isChecked ? "core.darkGreen.7" : "semantic.border.primary", borderRadius: "full", border: "none", flexShrink: 0, isReadOnly: isReadOnly, sx: {
                            _focus: {
                                border: "none",
                            },
                            _hover: {
                                backgroundColor: isChecked
                                    ? "semantic.interactive.primary"
                                    : "semantic.cta.secondaryHover",
                                border: "2px solid",
                                borderColor: "semantic.interactive.primary",
                            },
                            _disabled: {
                                _active: {
                                    backgroundColor: "semantic.background.disabled",
                                },
                                border: "none",
                                backgroundColor: "semantic.background.disabled",
                            },
                            _readOnly: {
                                _active: {
                                    border: "2px solid",
                                    borderColor: "semantic.icon.secondary",
                                    backgroundColor: "transparent",
                                },
                                border: "2px solid",
                                borderColor: "semantic.icon.secondary",
                                backgroundColor: "transparent",
                            },
                            _focusVisible: Object.assign({ backgroundColor: isChecked
                                    ? "semantic.interactive.primary"
                                    : "semantic.cta.secondaryHover", outlineStyle: "solid", outlineWidth: "3px", outlineColor: "semantic.outline.focus", outlineOffset: "2px" }, (!isChecked
                                ? {
                                    border: "2px solid",
                                    borderColor: "semantic.interactive.primary",
                                }
                                : {})),
                            _active: {
                                backgroundColor: "semantic.cta.secondaryPressed",
                                border: "none",
                            },
                        } }, props)), _jsx(Box, Object.assign({ className: "thumb", sx: !isDisabled && !isReadOnly
                            ? {
                                "input:has(+ &:hover)": {
                                    backgroundColor: isChecked
                                        ? "semantic.interactive.primary"
                                        : "semantic.cta.secondaryHover",
                                    border: "2px solid",
                                    borderColor: "semantic.interactive.primary",
                                },
                                "input:has(+ &:active)": {
                                    backgroundColor: "semantic.cta.secondaryPressed",
                                    border: "none",
                                },
                            }
                            : {}, transition: "all 0.15s ease-in", transform: isChecked ? "translateX(-1.5rem)" : "translateX(-2.75rem)", position: "relative", cursor: getCursorFromInputState({ isDisabled, isReadOnly }), top: "0.25rem", left: "0.25rem", w: "1rem", minWidth: "1rem", h: "1rem", minHeight: "1rem", backgroundColor: getThumbBackgroundColorFromInputState({
                            isDisabled,
                            isReadOnly,
                        }), borderRadius: "full", display: "flex", alignItems: "center", justifyContent: "center" }, { children: isDisabled ? null : (_jsx(SvgSpriteConsumer, { svgId: isChecked ? "switchOn16" : "switchOff16", color: getThumbColorFromInputState({ isReadOnly }), size: 8 })) }))] })), !isLeftLabel && children] })));
});
Switch.displayName = "Switch";
export default Switch;
//# sourceMappingURL=Switch.js.map